import { imageUrl } from 'app/frontend/base/helpers'

type EncounterCreatureInfo = {
  id: number
  name: string
}

export const ENCOUNTER_GATEWAY_VALUE = 'gateway'

export const ENCOUNTER_GATEWAY_ITEM = {
  value: ENCOUNTER_GATEWAY_VALUE,
  label: 'Demonic Gateway',
}

let activeEncounterId: number | undefined
let labelsById: Record<string, string> = {}

export const isEncounterGateway = (value: string) =>
  value === ENCOUNTER_GATEWAY_VALUE

export const setActiveEncounterCreatures = (
  encounterId: number | undefined,
  creatures: EncounterCreatureInfo[],
) => {
  activeEncounterId = encounterId
  labelsById = Object.fromEntries(
    creatures.map((creature) => [String(creature.id), creature.name]),
  )
}

export const encounterCreatureImageSrc = (
  creatureId: string,
  encounterId?: number,
) => {
  if (isEncounterGateway(creatureId)) {
    return imageUrl('encounter-creatures/gateway.png')
  }
  const resolvedEncounterId = encounterId ?? activeEncounterId
  if (resolvedEncounterId === undefined) return ''
  return imageUrl(
    `encounter-creatures/${resolvedEncounterId}/${creatureId}.png`,
  )
}

export const encounterCreatureLabel = (creatureId: string) => {
  if (isEncounterGateway(creatureId)) return ENCOUNTER_GATEWAY_ITEM.label
  return labelsById[creatureId] ?? creatureId
}
